module.exports = __webpack_public_path__ + "static/carlsbad-7-a89307a24ca904ede854b6e5991fcde1.png";